// Third party libraries
import _ from 'lodash';
import { useEffect, useState } from 'react';
import { Image } from 'semantic-ui-react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';

// Components
import HorizontalPlanCard from '../../../setup/checkout/plans/components/horizontalPlanCard';

// Models
import PaymentModel, { PeriodicityEnum, Plan } from '../../../../../models/payment';

// Redux Store
import { closeLoader, openLoader } from '../../../../../redux-store/loader';

// Locales
import I18n from '../../../../../i18n';

// Styles
import './index.scss';

// Assets
import FlexibilityYourBusiness from '../../../../assets/img/landing/flexibilityYourBusiness.png'
import GrowthUpValue from '../../../../assets/img/landing/growthUpValue.png'
import IncreaseIncome from '../../../../assets/img/landing/increaseIncome.png'
import RegisterBackground from '../../../../assets/img/registerBackground.png';
import YogabotLogo from '../../../../assets/img/YogabotPro.png';

interface RegisterCheckoutProps {

};

const RegisterCheckout = ({}: RegisterCheckoutProps) => {

    const navigate = useNavigate();
    const [searchParams] = useSearchParams();

    const dispatch = useDispatch();

    const [periodicity, setPeriodicity] = useState<PeriodicityEnum | null>(searchParams.get('periodicity') as PeriodicityEnum);
    const [selectedPlan] = useState<Plan | undefined>();
    const [plans, setPlans] = useState<Plan[]>([]);

    useEffect(()=> {

        getData();

    }, []);

    const getData = async () => {

        dispatch(openLoader());

        try {

            const plans = await PaymentModel.getPlans();

            setPlans(plans);
            
        } catch (e) { } finally {

            dispatch(closeLoader());

        }

    }

    const renderPlans = (periodicity: PeriodicityEnum | null, selectedPlan: Plan | undefined)=> {

        if(!plans || plans.length === 0) return <div>No plans</div>

        return plans.map(plan => {

            const offer = plan.generalOffers?.find(offer => offer.type === periodicity);

            return <HorizontalPlanCard key={ plan._id } maxStudents={ plan.maxStudents } plan={ plan } offer={ offer } periodicity={ periodicity } selected={ selectedPlan?._id === plan._id } onSelect={ () => navigate(`/setup/checkout?periodicity=${ periodicity }&plan=${ plan._id }`) } />
        } )
        
    }

    return <div className='registerCheckout'>
        <Image src={ RegisterBackground } className='background' />
        <div className='registerTab'>
            <div className='registerSelectPlan'>
                <div className='header'>
                    <Image src={ YogabotLogo } className='logo' />
                    <span className='stepText'>{ I18n.t('register.stepText', { currentStep: 2, totalSteps: 2 }) }</span>
                    <span className='title'>{ I18n.t('register.selectYourPlan') }</span>
                </div>
                <div className='periodicitySelector'>
                    <span className={ `selector ${ periodicity === PeriodicityEnum.Monthly ? 'active' : '' }` } onClick={ () => setPeriodicity(PeriodicityEnum.Monthly) }>{ I18n.t('landing.monthly') }</span>
                    <span className={ `selector ${ periodicity !== PeriodicityEnum.Monthly ? 'active' : '' }` } onClick={ () => setPeriodicity(PeriodicityEnum.Annual) }>{ I18n.t('landing.annual') }</span>
                </div>

                {renderPlans(periodicity, selectedPlan)}

            </div>
        </div>
        <div className='commercialTips'>
            <div className='benefit'>
                <Image src={ FlexibilityYourBusiness } />
                <div className='benefitText'>
                    <span className='title'>{ I18n.t('landing.flexibilityYourBusiness') }</span>
                    <br />
                    <span className='text'>{ I18n.t('landing.flexibilityYourBusinessText') }</span>
                </div>
            </div>
            <div className='benefit'>
                <Image src={ GrowthUpValue } />
                <div className='benefitText'>
                    <span className='title'>{ I18n.t('landing.growthUpValue') }</span>
                    <br />
                    <span className='text'>{ I18n.t('landing.growthUpValueText') }</span>
                </div>
            </div>
            <div className='benefit'>
                <Image src={ IncreaseIncome } />
                <div className='benefitText'>
                    <span className='title'>{ I18n.t('landing.increaseYourIncome') }</span>
                    <br />
                    <span className='text'>{ I18n.t('landing.increaseYourIncomeText') }</span>
                </div>
            </div>
        </div>
    </div>;

}

export default RegisterCheckout;